export function makeExportFile(blob, filename) {
  if (!blob?.size) throw new Error('The export is empty. Please export your card again.');
  const types = { png: 'image/png', gif: 'image/gif', mp4: 'video/mp4', webm: 'video/webm', pdf: 'application/pdf' };
  const type = types[filename.split('.').pop().toLowerCase()] || blob.type;
  return typeof File === 'function' ? new File([blob], filename, { type }) : null;
}

export function canShareExport(file, browser = navigator) {
  try { return !!file && typeof browser.share === 'function' && browser.canShare?.({ files: [file] }) === true; }
  catch { return false; }
}

export function isTouchExportDevice(browser = navigator) {
  return browser.maxTouchPoints > 0 || /iPhone|iPad|iPod|Android/i.test(browser.userAgent || '');
}

export function isAppleExportDevice(browser = navigator) {
  return /iPhone|iPad|iPod/i.test(browser.userAgent || '') || (/Macintosh/i.test(browser.userAgent || '') && browser.maxTouchPoints > 1);
}

export function exportFileSize(bytes) {
  return bytes < 1000000 ? `${Math.max(1, Math.round(bytes / 1000))} KB` : `${(bytes / 1000000).toFixed(1)} MB`;
}

export function downloadExportBlob(blob, filename) {
  const href = URL.createObjectURL(blob), link = document.createElement('a');
  link.download = filename; link.href = href; document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(href), 30000);
}
